import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "../Components/Axios/Axios";
import { Container, Button, Card, Form, Col, Row } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../Components/Sidebar/MainSidebar/Sidebar";
import Loader from "../Components/Spinner/Spinner";
import requests from "../Components/Requests/Requests";
import { useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles

function EditFaq(props) {
  const history = useHistory();
  const data = props.location.state;
  console.log(data, "rrrrrrrrrrrrrrrrr");
  const allTypes = ["android", "ios", "macos", "windows", "webapp"];
  const [id, setId] = useState(data.id.toString());
  const [titles, setTitles] = useState({
    en: data.name_en,
    ru: data.name_ru,
    pt: data.name_pt,
    de: data.name_de,
    fr: data.name_fr,
    es: data.name_es,
    kk: data.name_kk,
    hi: data.name_hi,
    "zh-CN": data.name_zh_CN,
    "zh-TW": data.name_zh_TW,
    uk: data.name_uk,
    ar: data.name_ar,
    tr: data.name_tr,
    he: data.name_he,
    it: data.name_it,
    ca: data.name_ca,
    hr: data.name_hr,
    cs: data.name_cs,
    da: data.name_da,
    nl: data.name_nl,
    fi: data.name_fi,
    el: data.name_el,
    hu: data.name_hu,
    no: data.name_no,
    pl: data.name_pl,
    ro: data.name_ro,
    sk: data.name_sk,
    sv: data.name_sv,
    ko: data.name_ko,
    th: data.name_th,
    vi: data.name_vi,
    ja: data.name_ja,
    id: data.name_id,
    ms: data.name_ms,
  });
  const [title, setTitle] = useState("");
  const [transData, setTransData] = useState({});
  const [descriptions, setDescriptions] = useState({});
  const [editorValue, setEditorValue] = useState(data.description);
  const [status, setStatus] = useState(data.status.toString());
  const [type, setType] = useState(data.faq_type);
  const [icon, setIcon] = useState("");
  const [faqVideo, setFaqVideo] = useState(data.video);
  const [faqkeywords, setFaqkeywords] = useState(data.keywords);
  const [loading, setLoading] = useState(false);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const LANGUAGES = [
    { key: "english", label: "English", code: "en" },
    { key: "russian", label: "Russian", code: "ru" },
    { key: "portuguese", label: "Portuguese", code: "pt" },
    { key: "german", label: "German", code: "de" },

    { key: "french", label: "French", code: "fr" },
    { key: "spanish", label: "Spanish", code: "es" },
    { key: "kazakh", label: "Kazakh", code: "kk" },
    { key: "hindi", label: "Hindi", code: "hi" },

    { key: "chinese_simplified", label: "Chinese (Simplified)", code: "zh-CN" },
    {
      key: "chinese_traditional",
      label: "Chinese (Traditional)",
      code: "zh-TW",
    },

    { key: "ukrainian", label: "Ukrainian", code: "uk" },
    { key: "arabic", label: "Arabic", code: "ar" },
    { key: "turkish", label: "Turkish", code: "tr" },
    { key: "hebrew", label: "Hebrew", code: "he" },

    { key: "italian", label: "Italian", code: "it" },
    { key: "catalan", label: "Catalan", code: "ca" },
    { key: "croatian", label: "Croatian", code: "hr" },
    { key: "czech", label: "Czech", code: "cs" },

    { key: "danish", label: "Danish", code: "da" },
    { key: "dutch", label: "Dutch", code: "nl" },
    { key: "finnish", label: "Finnish", code: "fi" },
    { key: "greek", label: "Greek", code: "el" },

    { key: "hungarian", label: "Hungarian", code: "hu" },
    { key: "norwegian", label: "Norwegian", code: "no" },
    { key: "polish", label: "Polish", code: "pl" },
    { key: "romanian", label: "Romanian", code: "ro" },

    { key: "slovak", label: "Slovak", code: "sk" },
    { key: "swedish", label: "Swedish", code: "sv" },
    { key: "korean", label: "Korean", code: "ko" },
    { key: "thai", label: "Thai", code: "th" },

    { key: "vietnamese", label: "Vietnamese", code: "vi" },
    { key: "japanese", label: "Japanese", code: "ja" },
    { key: "indonesian", label: "Indonesian", code: "id" },
    { key: "malay", label: "Malay", code: "ms" },
  ];

  // const handleCheckboxChange = (e) => {
  //   const value = e.target.value;

  //   let updated = [...selectedTypes];

  //   if (updated.includes(value)) {
  //     updated = updated.filter((item) => item !== value);
  //   } else {
  //     updated.push(value);
  //   }

  //   setSelectedTypes(updated);
  // };

  const addNewFaq = async () => {
    // const formData = new FormData();
    // formData.append("id", id);
    // formData.append("que", title);
    // formData.append("ans", editorValue);

    // formData.append("status", status);
    // formData.append("type",type);
    if (window.navigator.onLine) {
      setLoading(true);
      const formData = new FormData();

      formData.append("titles", JSON.stringify(titles));

      formData.append("id", id);

      const body = {
        id: id,
        titles: JSON.stringify(titles),
      };
      try {
        const responce = await axios.post(requests.editCategory, body);
        // console.log("result........",responce);
        if (responce.data.Success === 1) {
          // console.log(responce);
          toast.success("Category editted successfully!!", {
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setTimeout(() => {
            history.push("/allLessonCategories");
          }, 2500);
        } else {
          setLoading(false);
          toast.warning(`Something went wrong`, {
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } catch (err) {
        toast.warning(err, {
          position: "top-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      // console.log("body.....", body);
    } else {
      toast.error(`No internet connection`, {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  return (
    <>
      <Sidebar />
      <Container className="content">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Card>
          <Card.Header className="heading">Edit Category</Card.Header>
          <Card.Body>
            <Row>
              <Col className="main">
                {LANGUAGES.map((lang) => {
                  const t = transData[lang.code] || {};

                  return (
                    <div key={lang.code}>
                      {/* Title */}
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Name{" "}
                          {lang.code === "en" ? (
                            <span className="mandatory">*</span>
                          ) : (
                            ""
                          )}
                          ({lang.code})
                        </Form.Label>

                        <Form.Control
                          type="text"
                          placeholder={`Name in ${lang.label}`}
                          value={titles[lang.code] || ""} // all values stored here
                          onChange={(e) => {
                            const value = e.target.value;

                            // 1️⃣ Update unified titles state
                            setTitles((prev) => ({
                              ...prev,
                              [lang.code]: value,
                            }));

                            // 2️⃣ English name → update existing main title

                            // 3️⃣ Non-English → update translation data
                          }}
                        />
                      </Form.Group>
                    </div>
                  );
                })}
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer className="footer">
            {loading == true ? (
              <Loader margin={0} />
            ) : (
              <Button
                className="submit-btn"
                onClick={() => addNewFaq()}
                variant="primary"
              >
                Submit
              </Button>
            )}
          </Card.Footer>
        </Card>
      </Container>
    </>
  );
}

export default EditFaq;
